import Timer from './Timer';

export default Timer;


// WEBPACK FOOTER //
// /src/components/header/timer/index.js